<template>
  <BootstrapBadge :variant="variant">{{ label }}</BootstrapBadge>
</template>
<script setup lang="ts">
import {LoginPolicy} from '@/api/apolloPlatform/loginPolicy';

const props = defineProps<{loginPolicy: LoginPolicy}>();

const {translate} = useLocalisation();

const variant = computed(() => (props.loginPolicy.active ? 'success' : 'secondary'));
const label = computed(() =>
  translate(
    props.loginPolicy.active ? 'Active' : props.loginPolicy.frozen ? 'Deactivated' : 'Draft',
  ),
);
</script>
